import React, { useState, useEffect } from "react";
import { includes } from "lodash";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, NavItem } from "reactstrap";
import { Alert } from "bootstrap";
const Subheader = (props) => {
  const { pathname } = useLocation();

  const rendernetworkwebsite = () => {
    return (
      <NavItem>
        <Link
          to="/"
          className={`nav-link ${includes(pathname, "/") ? "active" : ""
            }`}
        >
          <img className="me-2" />
         
        </Link>
      </NavItem>
    )

  }

 

  return (
   
    <Navbar color="grey"  >
    <Nav>
     {rendernetworkwebsite()}
   </Nav>
    </Navbar>
  )
};

export default Subheader;
